<template>
<div class="comment-modal__content">
  <div class="comment-modal__content__header">
    <div class="comment-modal-title">エラーメッセージ：{{message}}</div>
  </div><!-- /.modal__content__header -->

  <div class="comment-modal__content__footer">
    <div class="comment-modal-btn-group"></div>

    <div class="comment-modal-btn-group">
      <button class="btn btn-edit" type="button" @click="hideModal"><span class="btn-text">OK</span></button>
    </div>
  </div><!-- /.modal__content__footer -->
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'modalDelete',
  computed: {
    ...mapState('modal', ['message'])
  },
  methods: {
    ...mapMutations('modal', ['hideModal'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/modal/modalError.vue